import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";

// Routes where the native Smartsupp launcher bubble must stay hidden
// (it overlaps the bottom nav / Funds button). Support is opened via the
// dedicated "Live chat" button instead (see SupportButton).
const HIDE_PREFIXES = ["/dashboard", "/admin"];

const ChatVisibility = () => {
  const { pathname } = useLocation();
  const timer = useRef(null);

  useEffect(() => {
    const shouldHide = HIDE_PREFIXES.some((p) => pathname.startsWith(p));
    const ss = () => (typeof window.smartsupp === "function" ? window.smartsupp : null);

    if (timer.current) {
      clearInterval(timer.current);
      timer.current = null;
    }

    if (shouldHide) {
      // The widget can initialise well after navigation, and re-show itself.
      // Keep enforcing "hidden" until the user explicitly opens it via the
      // Live chat button (window.__nwChatManual).
      const enforce = () => {
        const s = ss();
        if (s && !window.__nwChatManual) s("chat:hide");
      };
      enforce();
      timer.current = setInterval(enforce, 600);
    } else {
      window.__nwChatManual = false;
      const s = ss();
      if (s) s("chat:show");
    }

    return () => {
      if (timer.current) clearInterval(timer.current);
    };
  }, [pathname]);

  return null;
};

export default ChatVisibility;
